import type { PortfolioDetail } from '@repo/api-contracts';
import type { ReactElement } from 'react';

interface PortfolioCompanyInfoProps {
  readonly detail: PortfolioDetail;
}

const ROW_CLASS =
  'grid gap-4 border-t border-foreground py-10 lg:grid-cols-[minmax(0,1fr)_minmax(0,2fr)] lg:gap-10';

/**
 * 사례 이야기 — 회사소개·제작배경을 굵은 선으로 나눈 두 줄로 싣는다(왼쪽 제목, 오른쪽 본문).
 * 본문은 관리자가 입력한 일반 텍스트 그대로 — 줄바꿈만 살리고 HTML 로 해석하지 않는다.
 */
export const PortfolioCompanyInfo = ({ detail }: PortfolioCompanyInfoProps): ReactElement => (
  <div className="min-w-0 wrap-anywhere">
    <section aria-labelledby="portfolio-company-introduction" className={ROW_CLASS}>
      <div className="flex flex-col gap-2">
        <p aria-hidden className="text-sm text-muted-foreground">
          About
        </p>
        <h2
          id="portfolio-company-introduction"
          className="text-2xl leading-tight font-bold tracking-[-0.02em]"
        >
          회사소개
        </h2>
      </div>
      <p className="max-w-3xl text-[15px] leading-8 whitespace-pre-wrap sm:text-base sm:leading-8">
        {detail.companyIntroduction}
      </p>
    </section>
    <section aria-labelledby="portfolio-production-background" className={ROW_CLASS}>
      <div className="flex flex-col gap-2">
        <p aria-hidden className="text-sm text-muted-foreground">
          Background
        </p>
        <h2
          id="portfolio-production-background"
          className="text-2xl leading-tight font-bold tracking-[-0.02em]"
        >
          제작배경
        </h2>
      </div>
      <p className="max-w-3xl text-[15px] leading-8 whitespace-pre-wrap sm:text-base sm:leading-8">
        {detail.productionBackground}
      </p>
    </section>
  </div>
);
